import { render } from "./Code.vue?vue&type=template&id=0451c168&scoped=true"
import script from "./Code.vue?vue&type=script&lang=js"
export * from "./Code.vue?vue&type=script&lang=js"

import "./Code.vue?vue&type=style&index=0&id=0451c168&lang=scss&scoped=true"
import "./Code.vue?vue&type=style&index=1&id=0451c168&lang=scss"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0451c168"]])

export default __exports__